import React, { useContext } from "react";
import {
  Box,
  Button as ButtonBase,
  CircularProgress as CircularProgressBase,
} from "@mui/material";
import { ThemeProvider, createTheme, useTheme } from "@mui/material/styles";
import { FormContext } from "../../../contexts";
import { LegalConsentField } from "./legalConsentField";

const CircularProgress = ({ useMainColor, ...props }) => (
  <CircularProgressBase size={24} {...props} />
);

const Button = ({ fullWidth = true, isSaving, label, disabled, ...props }) => (
  <ButtonBase
    {...props}
    fullWidth={fullWidth}
    color="primary"
    type="submit"
    disabled={disabled}
  >
    {!isSaving ? (
      label
    ) : (
      <CircularProgress
        useMainColor={props.variant === "text" || props.variant === "outlined"}
      />
    )}
  </ButtonBase>
);

export const SubmitButton = ({
  color,
  label,
  alignment,
  marginTop,
  ...props
}) => {
  const currentTheme = useTheme();
  const { isSaving, legalConsentAccepted } = useContext(FormContext);

  const newTheme = createTheme({
    ...currentTheme,
    ...(color && {
      palette: {
        ...currentTheme.palette,
        primary: {
          main: color,
        },
      },
    }),
  });

  return (
    <ThemeProvider theme={newTheme}>
      <Box
        sx={{
          width: "100%",
          height: "100%",
          display: "flex",
          flexDirection: "column",
          pt: marginTop,
        }}
      >
        <Box sx={{ mb: 2 }}>
          <LegalConsentField />
        </Box>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: alignment,
          }}
        >
          <Button
            isSaving={isSaving}
            disabled={isSaving || !legalConsentAccepted}
            label={label}
            {...props}
          />
        </Box>
      </Box>
    </ThemeProvider>
  );
};
